import {
  GroupResponse,
  MoveGroupRequest,
  NewGroupRequest,
  NewGroupResponse,
  RenameGroupRequest,
  RenameVariableRequest,
  RestoreGroupsRequest,
  SensorInformationLookup,
  SortGroupRequest,
} from 'sigma-mappings';
import Http from '@/services/http';
import translate from '@/services/translate';

const urls = {
  getGeneralTabGroups: assetModuleId => `/supervisao/${assetModuleId}/grupos/geral`, // [GET]
  getGroupParametersTabGroups: assetModuleId => `/supervisao/${assetModuleId}/grupos/parametro`, // [GET]
  hideVariable: variableId => `/supervisao/campo/${variableId}/ocultar`, // [PUT]
  showVariable: variableId => `/supervisao/campo/${variableId}/exibir`, // [PUT]
  newGroup: '/supervisao/grupo', // [POST]
  deleteGroup: id => `/supervisao/grupo/${id}`, // [DELETE]
  moveVariable: id => `/supervisao/campo/${id}/mover`, // [PUT]
  renameGroup: id => `/supervisao/grupo/${id}`, // [PUT]
  renameVariable: id => `/supervisao/campo/${id}/renomear`, // [PUT]
  resetVariableName: id => `/supervisao/campo/${id}/limpar-nome`, // [PUT]
  getSensorInformation: assetModuleId => `/supervisao/${assetModuleId}/informacoes`,
  sortGroups: assetModuleId => `/supervisao/${assetModuleId}/grupos/reordenar`,
  restoreGroups: '/supervisao/grupos/restaurar', // [PUT]
};

function handleGeneralGroupName(apiGroup) {
  return apiGroup.default ? translate('general.general') : apiGroup.name;
}

function getMappedTabGroups(data) {
  return data.map((item) => {
    const mappedItem = new GroupResponse(item);
    mappedItem.name = handleGeneralGroupName(mappedItem);
    return mappedItem;
  });
}

export default {
  getParametersTabList(assetModuleId) {
    const http = new Http();
    return http
      .get(urls.getGroupParametersTabGroups(assetModuleId))
      .then(({ data }) => getMappedTabGroups(data));
  },
  getGeneralTabList(id) {
    const http = new Http();
    return http
      .get(urls.getGeneralTabGroups(id))
      .then(({ data }) => getMappedTabGroups(data));
  },
  moveVariable(payload, id) {
    const http = new Http();
    const mappedPayload = new MoveGroupRequest(payload);
    return http
      .put(urls.moveVariable(id), mappedPayload)
      .then(({ data }) => data);
  },
  deleteGroup(id) {
    const http = new Http();
    return http
      .delete(urls.deleteGroup(id))
      .then(({ data }) => data);
  },
  toggleVariableVisibility(id, visibility) {
    const http = new Http();
    const url = visibility ? urls.hideVariable : urls.showVariable;
    return http
      .put(url(id))
      .then(({ data }) => data);
  },
  createNewSupervisionGroup(payload) {
    const http = new Http();
    const mappedPayload = new NewGroupRequest(payload);
    return http
      .post(urls.newGroup, mappedPayload)
      .then(({ data }) => new NewGroupResponse(data));
  },
  renameGroup(payload, groupId) {
    const http = new Http();
    const mappedPayload = new RenameGroupRequest(payload);
    return http
      .put(urls.renameGroup(groupId), mappedPayload)
      .then(({ data }) => data);
  },
  renameVariable(payload, variableId) {
    const http = new Http();
    const mappedPayload = new RenameVariableRequest(payload);
    return http
      .put(urls.renameVariable(variableId), mappedPayload)
      .then(({ data }) => data);
  },
  resetVariableName(variableId) {
    const http = new Http();
    return http
      .put(urls.resetVariableName(variableId))
      .then(({ data }) => data);
  },
  getSensorInformation(assetModuleId) {
    const http = new Http();
    return http
      .get(urls.getSensorInformation(assetModuleId))
      .then(({ data }) => data.map(item => new SensorInformationLookup(item)));
  },
  sortGroups(sensoerId, payload) {
    const http = new Http();
    const mappedPayload = new SortGroupRequest({
      sortedIds: payload,
    });
    return http
      .post(urls.sortGroups(sensoerId), mappedPayload);
  },
  restoreGroups(assetModules) {
    const http = new Http();
    const mappedPayload = new RestoreGroupsRequest({
      assetModules,
    });
    return http
      .put(urls.restoreGroups, mappedPayload)
      .then(({ data }) => data);
  },
};
